export default {
    suggestionGroups: [],
};
